import { h } from 'preact'

const LoaderIcon = ({
  size = 24,
  color = '#429EFF',
  className,
}: {
  size?: number
  color?: string
  className?: string
}) => (
  <svg className={className} width={size} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 148 148">
    <path
      d="M74 146.15C74 147.172 73.1714 148.002 72.15 147.977C59.801 147.668 47.7149 144.272 37 138.086C25.7506 131.591 16.409 122.249 9.91412 111C3.41926 99.7506 -1.71628e-06 86.9897 0 74C1.71628e-06 61.0103 3.41927 48.2494 9.91413 37C16.409 25.7506 25.7506 16.409 37 9.91411C48.2494 3.41926 61.0103 -2.86476e-06 74 0C86.9897 2.86477e-06 99.7506 3.41927 111 9.91413C121.715 16.1004 130.699 24.8693 137.141 35.4094C137.674 36.2812 137.369 37.4142 136.484 37.925C135.599 38.4359 134.47 38.1312 133.936 37.2601C127.819 27.282 119.302 18.9799 109.15 13.1184C98.4631 6.94831 86.3402 3.70001 74 3.7C61.6598 3.7 49.537 6.9483 38.85 13.1184C28.1631 19.2885 19.2885 28.163 13.1184 38.85C6.94831 49.5369 3.70001 61.6598 3.7 74C3.7 86.3402 6.9483 98.463 13.1184 109.15C19.2885 119.837 28.163 128.711 38.85 134.882C49.0024 140.743 60.4506 143.968 72.15 144.276C73.1714 144.303 74 145.128 74 146.15Z"
      fill={color}
    />
  </svg>
)

export default LoaderIcon
